module.exports = __webpack_public_path__ + "static/media/bookmark.864b58c7.svg";